<template>
  <section class="content">
    <admin-header
      :title="'Users'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminUser',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - Users',
        searchEntityScreen: 'Admin - User search',
        filterEventName: 'admin-user-filter',
        filterName: 'UserFilter',
        entityName: 'mai-user'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminUser.vue?2dd3df56